import { useFormik } from "formik";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CartTotal } from "../../Common/Components/CartTotal";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import LaundryItemCard from "../../Common/Components/LaundryItemCard";
import ServicePicker from "../../Common/Components/ServicePicker";
import { TitleHeader } from "../../Common/Components/TitleHeader";
import useCartTotal from "../../Common/Hooks/useCartTotal";
import {
  calculateBundleOffer,
  fetchLaundryItem,
  fetchServices,
  getBundleMessage,
} from "../../Services/CartService";
import { BsSearch } from "react-icons/bs";

const LaundryService = () => {
  const [services, setServices] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [initLoading, setInitLoading] = React.useState(true);
  const [itemsLoading, setItemsLoading] = React.useState(false);
  const [laundryItems, setLaundryItem] = React.useState([]);
  const [campaign, setCampaign] = React.useState(null);
  const [payload, setPayload] = React.useState({
    serviceId: null,
    categoryId: null,
    limit: 100,
    offset: 1,
  });
  const [cShow, setCShow] = React.useState(false);
  const lastService = useSelector((x) => x.Service);
  const lastCategory = useSelector((x) => x.Category);
  const cart = useSelector((x) => x.Cart);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const bookingType = useSelector((x) => x.BookingType);
  const config = useSelector((x) => x.Config);
  const [amount, total] = useCartTotal();
  const [reload, setReload] = React.useState("");
  const [tempServ, setTempServ] = React.useState(null);
  const [tempBook, setTempBook] = React.useState(null);
  const [search, setSearch] = React.useState("");
  const [fetchError, setFetchError] = React.useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      cart: {
        items: [],
      },
    },
  });

  React.useEffect(() => {
    if (!orderTypeId) {
      navigate("/app");
    } else {
      fetchServices(100, 1, orderTypeId).then(
        (res) => {
          setServices(res);
          let selectedService;
          if (lastService && lastService !== "null") {
            selectedService = res.find((x) => x.id === parseInt(lastService));
            setPayload((state) => ({
              ...state,
              serviceId: selectedService?.id,
            }));
          } else {
            selectedService = res[0];
            setPayload((state) => ({
              ...state,
              serviceId: selectedService?.id,
            }));
          }
          const cats = selectedService?.categories || [];
          setCategories(cats);
          let selectedCategory;
          if (lastCategory && lastCategory !== "null") {
            selectedCategory = cats.find(
              (x) => x.id === parseInt(lastCategory)
            );
            setPayload((state) => ({
              ...state,
              categoryId: selectedCategory?.id,
            }));
          } else {
            selectedCategory = cats[0];
            setPayload((state) => ({
              ...state,
              categoryId: selectedCategory?.id,
            }));
          }
          setInitLoading(false);
        },
        (er) => {
          console.warn("Something went wrong on services...");
        }
      );
    }
  }, []);

  // React.useEffect(() => {
  //   if (!initLoading && !itemsLoading) {
  //     setItemsLoading(true);
  //     setLaundryItem([]);
  //     fetchLaundryItem(payload).then(
  //       (res) => {
  //         setItemsLoading(false);
  //         setLaundryItem(res.data);
  //         setCampaign(res.campain[0]);
  //       },
  //       (er) => {
  //         setItemsLoading(false);
  //         setLaundryItem([]);
  //         console.warn(er, "error on laundry item.");
  //       }
  //     );
  //   }
  // }, [initLoading, payload, reload]);
  React.useEffect(() => {
  const controller = new AbortController();
  if (!initLoading) { // ← ! added
    setItemsLoading(true);
    setLaundryItem([]);
    setFetchError(false);
    fetchLaundryItem(payload, controller.signal).then(
      (res) => {
        if (controller.signal.aborted) return; // ← ! removed
        setItemsLoading(false);
        setLaundryItem(res.data);
        setCampaign(res.campain[0]);
      },
      (er) => {
        if (controller.signal.aborted) return;
        setItemsLoading(false);
        setLaundryItem([]);
        setFetchError(true);
      }
    );
  }
  return () => controller.abort();
}, [initLoading, payload, reload]);
  
  React.useEffect(() => {
    formik.setValues((y) => ({
      ...y,
      cart: {
        ...y.cart,
        items: laundryItems.map((x) => {
          const fCart = cart.find(
            (f) =>
              f.laundry_item_id === x.id && f.serviceId === x.services[0]?.id
          );
          const newPrice =
            bookingType == 2
              ? typeof x.services[0].pivot.e_price == "string"
                ? parseFloat(x.services[0].pivot.e_price)
                : x.services[0].pivot.e_price
              : typeof x.services[0].pivot.price == "string"
              ? parseFloat(x.services[0].pivot.price)
              : x.services[0].pivot.price;
          if (fCart) {
            const fadb9 = {
              ...fCart,
              addons: x.addons.map((z) => {
                const fAd = fCart.addons.find((ffAd) => ffAd.id === z.id);
                if (fAd) return fAd;
                else
                  return {
                    id: z.id,
                    name: z.name,
                    price: z.price,
                    qty: 0,
                  };
              }),
              price: newPrice,
              actualPrice: newPrice,
            };
            if (campaign) {
              fadb9.price =
                fadb9.price - fadb9.price * (campaign.discount / 100);
            }
            return fadb9;
          } else {
            const fadb9 = {
              laundry_item_id: x.id,
              laundry_item_category_id: parseInt(x.laundry_item_category_id),
              price: newPrice,
              actualPrice: newPrice,
              quantity: 0,
              name: x.name,
              serviceId: x.services[0]?.id,
              is_bundle_active: false,
              bundle_buy: x.bundle_offer?.required_items,
              bundle_free: x.bundle_offer?.total_discount_items,
              free_items: 0,
              addons: x.addons.map((z) => {
                return {
                  id: z.id,
                  name: z.name,
                  price: z.price,
                  qty: 0,
                };
              }),
              item_note: "",
            };
            if (campaign) {
              fadb9.price =
                fadb9.price - fadb9.price * (campaign.discount / 100);
            }
            return fadb9;
          }
        }),
      },
    }));
  }, [laundryItems, bookingType, campaign]);

  React.useEffect(() => {
    if (!initLoading) {
      const items = [...formik.values.cart.items];
      const currentCart = [...cart];
      const newItems = [...items];

      let updatedCart = currentCart.map((item) => {
        const newItem = newItems.find(
          (newItem) =>
            newItem.laundry_item_id === item.laundry_item_id &&
            newItem.serviceId === item.serviceId
        );
        return newItem || item;
      });

      newItems
        .filter((x) => x.quantity !== 0)
        .forEach((newItem) => {
          if (
            !updatedCart.find(
              (item) =>
                item.laundry_item_id === newItem.laundry_item_id &&
                item.serviceId === newItem.serviceId
            )
          ) {
            updatedCart.push(newItem);
          }
        });

      for (let i = 0; i < updatedCart.length; i++) {
        const x = updatedCart[i];
        const y = { ...x, addons: [] };

        if (x.quantity !== 0) {
          for (let j = 0; j < x.addons.length; j++) {
            const z = x.addons[j];
            if (z.qty !== 0) {
              y.addons.push(z);
            }
          }
          // newItems.push(y);
        }
        updatedCart[i] = y;
      }
      updatedCart = updatedCart.filter((x) => x.quantity !== 0);
      dispatch({ type: "setCart", payload: updatedCart });
    }
  }, [formik.values, initLoading, dispatch]);

  const selectService = (serviceId, clearTemp) => {
    setSearch("");
    if (
      orderTypeId != 1 &&
      orderTypeId != 2 &&
      serviceId != lastService &&
      total != 0 &&
      !clearTemp
    ) {
      setTempServ(serviceId);
    } else {
      setTempServ(null);
      const serv = services.find((x) => x.id == serviceId);
      const cats = serv.categories;
      setCategories(cats);
      setPayload((state) => ({ ...state, serviceId, categoryId: cats[0]?.id }));
      dispatch({ type: "setService", payload: serviceId });
    }
  };
  const selectCategory = (categoryId) => {
    setSearch("");
    setPayload((state) => ({ ...state, categoryId }));
    dispatch({ type: "setCategory", payload: categoryId });
  };
  const toggleAddons = (index) => {
    setLaundryItem((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, showAddons: !item.showAddons } : item
      )
    );
  };
  const changeItemQuantity = (index, value) => {
    formik.setValues((v) => ({
      cart: {
        items: v.cart.items.map((v, i) => {
          if (i === index) {
            const item = { ...v, quantity: value };
            if (item.bundle_buy > 0)
              item.free_items = calculateBundleOffer({
                totalQuantity: value,
                bundleBuy: item.bundle_buy,
                bundleFree: item.bundle_free,
                itemPrice: item.price,
              }).freeItems;

            item.is_bundle_active = item.free_items > 0;

            return item;
          }
          return v;
        }),
      },
    }));
  };
  const changeAddonQuantity = (itemIndex, addonIndex, qty) => {
    formik.setValues((v) => ({
      cart: {
        items: v.cart.items.map((v, i) =>
          i === itemIndex
            ? {
                ...v,
                addons: v.addons.map((ad, adI) =>
                  addonIndex === adI ? { ...ad, qty } : ad
                ),
              }
            : v
        ),
      },
    }));
  };
  const changeItemNote = (itemIndex, item_note) => {
  formik.setValues((v) => ({
    cart: {
      items: v.cart.items.map((item, i) =>
        i === itemIndex ? { ...item, item_note } : item
      ),
    },
  }));
  };
  const cCart = (serv, isServ = true) => {
    dispatch({ type: "setCart", payload: [] });
    formik.setValues({ cart: { items: [] } });
    if (isServ && serv) {
      setTimeout(() => {
        selectService(serv, true);
      }, 100);
    }
    if (!isServ && serv) {
      setTimeout(() => {
        handleBookingTypeChange(serv, true);
      }, 100);
    } else {
      dispatch({ type: "setService", payload: null });
      dispatch({ type: "setCategory", payload: null });
      dispatch({ type: "setPickupDate", payload: null });
      dispatch({ type: "setDeliveryDate", payload: null });
      dispatch({ type: "setAddresses", payload: null });
      setReload(Date.now().toString());
    }
  };
  const getLaundryItem = (id) => {
    return laundryItems.find((x) => x.id == id);
  };
  const handleBookingTypeChange = (id, clearTemp) => {
    if (total != 0 && !clearTemp) {
      setTempBook(id);
    } else {
      setTempBook(null);
      dispatch({
        type: "setBookingType",
        payload: id,
      });
    }
  };
  const getServiceName = (id) => {
    return services.find((x) => x.id == id)?.name;
  };
  const getOffer = (id) => {
    return getLaundryItem(id)?.bundle_offer;
  };

  const filteredItems = formik.values.cart.items
  .map((item, originalIndex) => ({ item, originalIndex }))
  .filter(({ item }) => {
    if (!search) return true;

    const li = getLaundryItem(item.laundry_item_id);
    const name = (li?.name || "").toLowerCase();
    const desc = (li?.description || "").toLowerCase();
    const q = search.toLowerCase();

    return name.includes(q) || desc.includes(q);
  });


  const ServicePickerMemo = React.memo(ServicePicker);

  return (
    <>
      <TitleHeader
        title={"Select Your Laundry"}
        subtitle={
          "Build your perfect laundry load by selecting your options below!"
        }
      />
      <div className="container">
        {initLoading ? (
          <>
            <div
              className="row justify-content-center align-items-center"
              style={{ height: "50vh" }}
            >
              <div
                className="spinner-border text-warning"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </>
        ) : (
          <>
            {orderTypeId != 1 && orderTypeId != 2 ? (
              <div
                className="d-flex justify-content-center row-gap-3 column-gap-3"
                style={{ paddingTop: "40px" }}
              >
                <div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      checked={bookingType == 1}
                      id="regular-radio"
                      onChange={(e) =>
                        handleBookingTypeChange(e.target.checked ? 1 : null)
                      }
                      type="radio"
                    />
                    <label className="form-check-label" htmlFor="regular-radio">
                      Regular
                    </label>
                  </div>
                </div>
                <div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      id="express-radio"
                      checked={bookingType == 2}
                      onChange={(e) =>
                        handleBookingTypeChange(e.target.checked ? 2 : null)
                      }
                      type="radio"
                    />
                    <label className="form-check-label" htmlFor="express-radio">
                      Express
                    </label>
                  </div>
                </div>
              </div>
            ) : null}
            <ServicePickerMemo
              payload={payload}
              selectService={selectService}
              services={services}
            />
            {/* <div
              className="row justify-content-center row-gap-3 column-gap-3"
              style={{ padding: "40px 0px" }}
            >
              <div className="col-12 text-center">
                <span
                  style={{ fontSize: "18px", color: "#656565" }}
                  className="fw-bold"
                >
                  1. Choose Your Service
                </span>
              </div>
              <div
                className="row justify-content-start column-gap-3 row-gap-3 px-4 select-category-chip-container"
                style={{
                  flexWrap: "nowrap",
                  width: "100%",
                  overflowX: "auto",
                }}
              >
                {services.map((e) => (
                  <div
                    key={`service-card-${e.id}`}
                    className={`select-service-card ${
                      e.id === payload.serviceId ? "selected" : ""
                    }`}
                    onClick={() => selectService(e.id)}
                  >
                    <img
                      src={`${config?.["base_urls"]?.["services_image_url"]}/${e?.["icon"]}`}
                      alt=""
                    />
                    <span>{e.name}</span>
                  </div>
                ))}
              </div>
            </div> */}
            <div className="row">
              <div
                className="col-12 text-center"
                style={{ marginBottom: "17px" }}
              >
                <span
                  style={{ fontSize: "18px", color: "#656565" }}
                  className="fw-bold"
                >
                  2. Select Category
                </span>
              </div>
            </div>
            <div
              className="row justify-content-start justify-content-md-center column-gap-3 row-gap-3 px-4 select-category-chip-container"
              style={{
                marginBottom: "30px",
                flexWrap: "nowrap",
                width: "100%",
                overflowX: "auto",
              }}
            >
              {categories.map((e) => (
                <div
                  key={`category-id-${e.id}`}
                  className={`select-category-chip ${
                    e.id === payload.categoryId ? "selected" : ""
                  }`}
                  onClick={() => selectCategory(e.id)}
                >
                  {e.name}
                </div>
              ))}
            </div>
              <div className="row justify-content-center px-4 mb-3">
                <div className="col-lg-6 col-12">
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search items in this category"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      style={{
                        paddingLeft: "40px",
                        height: "44px",
                        borderRadius: "10px",
                        fontSize: "14px",
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "14px",
                        transform: "translateY(-50%)",
                        color: "#999",
                        fontSize: "18px",
                      }}
                    >
                      <BsSearch />
                    </span>
                    {search && (
                      <span
                        onClick={() => setSearch("")}
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "14px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#999",
                          fontSize: "18px",
                        }}
                      >
                        ×
                      </span>
                    )}
                  </div>
                </div>
              </div>

            <div className="row justify-content-center pt-4">
              <div className="col-12 text-center">
                <span
                  style={{ fontSize: "18px", color: "#656565" }}
                  className="fw-bold"
                >
                  3. Select your items below
                </span>
              </div>
              <div className="col-lg-10 col-12 my-3">
                <div
                  className={`row px-4 align-items-start justify-content-${
                    formik.values.cart.items?.length === 0
                      ? "center"
                      : "between"
                  }`}
                  style={{ rowGap: "16px" }}
                >
                  {itemsLoading ? (
                    <div className="col-12 text-center">
                      <div
                        className="spinner-border text-warning"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                    ) : fetchError ? (
                      <div className="col-12 text-center py-4">
                        <p className="text-danger mb-2">Failed to load items. Please check your connection.</p>
                        <button
                          className="btn btn-warning fw-semibold"
                          onClick={() => setReload(Date.now().toString())}
                        >
                          Retry
                        </button>
                      </div>
                    ) : formik.values.cart.items?.length === 0 ? (
                    <div className="col-auto d-flex align-items-center flex-column py-3">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/noitemicon.png"}
                        alt=""
                        style={{ width: "70px" }}
                      />
                      <h6 className="mt-3 mb-0">
                        There are no laundry items in this category...
                      </h6>
                    </div>
                  ) : (
                    filteredItems.length === 0 ? (
                      <div className="col-12 text-center">
                        <p className="text-muted mt-4">
                          No items found in this category
                        </p>
                      </div>
                    ) : (
                      filteredItems.map(({ item: e, originalIndex }) => (
                      <LaundryItemCard
                        key={`${e.laundry_item_id}-${e.serviceId}`}  
                        laundryItem={getLaundryItem(e.laundry_item_id)}
                        description={getLaundryItem(e.laundry_item_id)?.description}
                        campaign={campaign}
                        item={e}
                        itemIndex={originalIndex}                   
                        changeAddonQuantity={changeAddonQuantity}
                        changeItemQuantity={changeItemQuantity}
                        toggleAddons={toggleAddons}
                        offer={getOffer(e.laundry_item_id)}
                        bundleMessage={getBundleMessage(e)}
                        onNoteChange={(note) => changeItemNote(originalIndex, note)}
                      />
                    ))
                    )

                    // formik.values.cart.items?.map((e, itemIndex) => (
                    //   <LaundryItemCard
                    //     key={itemIndex}
                    //     laundryItem={getLaundryItem(e.laundry_item_id)}
                    //     description={getLaundryItem(e.laundry_item_id)?.description}
                    //     campaign={campaign}
                    //     item={e}
                    //     itemIndex={itemIndex}
                    //     changeAddonQuantity={changeAddonQuantity}
                    //     changeItemQuantity={changeItemQuantity}
                    //     toggleAddons={toggleAddons}
                    //     offer={getOffer(e.laundry_item_id)}
                    //     bundleMessage={getBundleMessage(e)}
                    //     onNoteChange={(item_note) => changeItemNote(itemIndex, item_note)}
                    //   />
                    // ))
                  )}
                </div>
              </div>
            </div>
            <CartTotal />
          </>
        )}
      </div>
      <div className="container-fluid bg-white">
        <div
          className="row justify-content-center"
          style={{ padding: "20px 0px" }}
        >
          <div
            className="d-flex col-lg-6 col-md-7 col-12 justify-content-center flex-column flex-md-row some-random-buttons"
            style={{ columnGap: "20px", rowGap: "10px" }}
          >
            {total > 0 ? (
              <div
                className="service-btn danger"
                onClick={() => setCShow(true)}
              >
                Clear Cart
              </div>
            ) : null}
            <Link className="service-btn cart" to="/app/cart">
              View Cart
            </Link>
            {/* {config.laundry_customer_minimum_purchase} {"<"}= {amount} &&{" "}
            {total} {"<"}0 */}
            {config.laundry_customer_minimum_purchase <= amount && total > 0 ? (
              <Link to="/app/summary" className="service-btn next">
                Next
              </Link>
            ) : (
              <div
                className="service-btn next"
                onClick={() =>
                  toast.error(
                    `Minimum order value should be above Rs.${config.laundry_customer_minimum_purchase}`
                  )
                }
              >
                Next
              </div>
            )}
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={cShow}
        text="Are you sure you want to clear your cart? "
        onNo={() => {
          setCShow(false);
        }}
        onYes={() => {
          setCShow(false);
          cCart();
        }}
      />
      <Modal
        show={tempServ || tempBook}
        onHide={() => {
          setTempServ(null);
          setTempBook(null);
        }}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="text-primary">Warning...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="fw-normal text-center">
            You already have {total} item(s) in your cart. If you change{" "}
            {tempBook ? "order type" : "service"} your cart will be cleared.
          </h5>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-between">
          <Button
            variant="primary"
            className="m-0 text-white fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              setTempServ(null);
              setTempBook(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="m-0 bg-dark text-white fw-semibold"
            style={{ width: "49%" }}
            onClick={() => {
              cCart(tempBook || tempServ, !Boolean(tempBook));
            }}
          >
            Change {tempBook ? "order type" : "service"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LaundryService;
